<div class="row space mt-4" [ngClass]="checkWidth ? 'contentClass' : ''" *ngIf="indexList?.length">
  <div class="row space">
    <div class="headingTitle">{{ title }}</div>
    <div class="toc-main">
      <div class="toc-sub">
        <p class="toc-sub-heading" *ngFor="let item of indexList; let i = index">
          <a
            style="cursor: pointer; display: flex"
            (click)="scrollToElement(title == 'Figures' ? i + 'figureIndex' : i + 'tableIndex')"
          >
            <div class="d-flex">
              <p [ngClass]="{ figureNumberText: true, tableNumberText: title === 'Tables' }">
                <span class="before-colon figureText">{{ item.split(':')[0] }}:</span>
              </p>
              <p class="figureStrText">
                <span class="after-colon figureText">{{ item.split(':')[1] }}</span>
              </p>
            </div>
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
